<template>
  <AppLoadingContainer :predicate="isLoading">
    <div class="card-body">
      <!-- The collapsable filter options -->
      <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
          <template v-slot:header>Filter</template>
          <template v-slot:body>
              <div class="form-row justify-content-center">
                  <b-form-group label="Lock Type" class="col-auto" v-slot="{ lockTypeValue }">
                      <b-form-radio-group
                            v-model="filterOptions.lockType"
                            :options="lockTypes"
                            :aria-describedby="lockTypeValue"
                          ></b-form-radio-group>
                  </b-form-group>
                  <div class="col-auto form-group">
                      <label for="buildingId">Building</label>
                      <select class="form-control" v-model="filterOptions.buildingId">
                          <option :value="null">All</option>
                          <option :key="possibleBuilding.id" :value="possibleBuilding.id" v-for="possibleBuilding in buildings">{{possibleBuilding.name}}</option>
                      </select>
                  </div>
                  <div class="col-md-4 form-group">
                      <label>Lock Notes/Name/Location</label>
                      <input
                              class="form-control"
                              placeholder="Notes/Name/Location"
                              v-model="filterOptions.lockIdentity"
                      />
                  </div>
              </div>
              <div class="form-row justify-content-center">
                  <b-form-group label="Search By" class="col-auto" v-slot="{ suiteOrRoomValue }">
                      <b-form-radio-group
                            v-model="searchForSuiteOrRoom"
                            :options="suiteOrRoom"
                            :aria-describedby="suiteOrRoomValue"
                          ></b-form-radio-group>
                  </b-form-group>
                  <div v-if="searchForSuiteOrRoom === 2" class="col-auto form-group">
                      <label>Suite</label>
                      <input
                              class="form-control"
                              placeholder="Suite"
                              v-model="filterOptions.suite"
                      />
                  </div>
                  <div v-if="searchForSuiteOrRoom === 1" class="col-auto form-group">
                      <label>Room</label>
                      <input
                              class="form-control"
                              placeholder="Room"
                              v-model="filterOptions.room"
                      />
                  </div>
                  
              </div>
          </template>
          <template v-slot:footer>
              <button class="btn btn-primary" type="submit">Apply</button>
          </template>
      </AppFormCardCollapsable>
      <div class="mb-2 text-right">
          <router-link :to="{name:'AddKeyLocks',params:{facilitiesKeyId:facilitiesKeyId,facilitiesKeyTypeName:facilitiesKeyTypeName,facilitiesKeyNumber:facilitiesKeyNumber,facilitiesKeyTypeId:facilitiesKeyTypeId}}"
                       class="btn btn-sm btn-primary d-print-none"
                       data-toggle="tooltip"
                       title="Add key locks">
              <i class="fa fa-plus"></i>Add Locks
          </router-link>
      </div>
      <BTable :busy="isLoading"
              :fields="tableFields"
              :items="facilitiesKeyLocks"
              :responsive="true"
              primary-key="id"
              show-empty
              striped
              table-class="table-align-middle">

          <template v-slot:cell(id)="row">
              <div class="btn-group col-auto">
                  <router-link
                          :to="{ name:'EditKeyLock', params:{ id: row.item.id, facilitiesKeyId: facilitiesKeyId, facilitiesKeyNumber: facilitiesKeyNumber, facilitiesKeyTypeName: facilitiesKeyTypeName } }"
                          class="btn btn-sm btn-warning d-print-none"
                          data-toggle="tooltip"
                          title="Edit key copy">
                      <i class="fa fa-pencil-alt"></i>Edit
                  </router-link>
                  <button @click="onDeleteClick(row.item)" class="btn btn-danger btn-sm d-print-none"
                          type="button"><i class="fa fa-trash"></i>Delete
                  </button>
              </div>
          </template>

          <template v-slot:cell(buildingId)="row">
              <span>{{ row.item.buildingName }} {{ row.item.spaceType }} {{ row.item.spaceIdentity }}</span>
          </template>

          <template v-slot:cell(createdDate)="row">
              <span>{{ row.item.createdDate | moment('MM/DD/YYYY') }}</span>
          </template>

          <template v-slot:cell(lastModifiedDate)="row">
              <span>{{ row.item.lastModifiedDate | moment('MM/DD/YYYY') }}</span>
          </template>

          <!-- Footer Pagination -->
          <template v-slot:custom-foot>
              <b-tr>
                  <b-td :colspan="tableFields.length">
                      <AppTablePagination
                              :page.sync="filterOptions.page"
                              :pageSize.sync="filterOptions.pageSize"
                              :totalCount.sync="totalFacilitiesKeyLocks"
                              v-on:update:page="loadData()"
                              v-on:update:pageSize="loadData()"
                      ></AppTablePagination>
                  </b-td>
              </b-tr>
          </template>
      </BTable>
    </div>

    <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
        <template v-slot:header>Confirm</template>
        <p v-if="deletingRow">Are you sure you want to delete lock{{ deletingRow.lockIdentity === null ? '' :  ' \'' + deletingRow.lockIdentity + '\'' }}
                          {{ deletingRow.buildingName === null ? '' : ' for ' + deletingRow.buildingName }}{{ deletingRow.spaceType === null ? '' : ' ' + deletingRow.spaceType }}{{ deletingRow.spaceIdentity === null ? '' : ' ' + deletingRow.spaceIdentity }}?</p>
    </AppModalConfirm>
  </AppLoadingContainer>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import AppModalConfirm from "@/components/shared/AppModalConfirm";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AddressService from '@/services/AddressService';

    export default {
        components: {
            AppTablePagination,
            AppLoadingContainer,
            AppModalConfirm,
            AppFormCardCollapsable
        },
        props: {
            facilitiesKeyId: {
                type: String,
                required: true
            },
            facilitiesKeyNumber: {
              type: String,
              required: true
            },
            facilitiesKeyTypeName: {
              type: String,
              required: true
            },
            facilitiesKeyTypeId: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                buildings: [],
                facilitiesKeyLocks: [],
                totalFacilitiesKeyLocks: 0,
                deletingRow: null,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    facilitiesKeyId: null,
                    lockType: null,
                    buildingId: null,
                    suite: null,
                    room: null,
                    lockIdentity: null
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:225px'
                    }, 
                    {
                        key: 'lockType',
                        label: 'Type'
                    },
                    {
                        key: 'lockIdentity',
                        label: 'Lock Notes/Name/Location',
                    },
                    {
                        key: 'buildingId',
                        label: 'Building'
                    },
                    {
                        key: 'notes',
                        label: 'Additional Notes',
                    },
                    {
                        key: 'createdDate',
                        label: 'Created Date',
                    },
                    {
                        key: 'lastModifiedDate',
                        label: 'Last Modified Date',
                    }
                ],
                lockTypes: [
                    {
                        value: null,
                        text: 'All'
                    },
                    {
                        value: 0,
                        text: 'Other'
                    },
                    {
                        value: 1,
                        text: 'Entrance/Door'
                    }
                ],
                searchForSuiteOrRoom: 0,
                suiteOrRoom: [
                    {
                        value: 0,
                        text: 'All'
                    },
                    {
                        value: 1,
                        text: 'Room'
                    },
                    {
                        value: 2,
                        text: 'Suite'
                    }
                ]
            }
        },
        watch: {
            searchForSuiteOrRoom (newVal) {
                this.filterOptions.room = null;
                this.filterOptions.suite = null;
            }
        },
        methods: {
            loadData() {
                const vm = this;
                vm.isLoading = true;

                FacilitiesKeysService.getFacilitiesKeyLocksForKey(this.facilitiesKeyId, vm.filterOptions)
                  .then(response => {
                    vm.facilitiesKeyLocks = response.data;
                    vm.totalFacilitiesKeyLocks = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },

            /**
             * @description Opens up a modal to confirm deletion of the key lock
             */
            onDeleteClick(keyCopy) {
                this.deletingRow = keyCopy;
            },

            /**
             * @description When the user clicks 'Confirm' - the selected key lock will be deleted and the modal will be closed.
             */
            onDeleteConfirmed(deletingRow) {
                const vm = this;

                FacilitiesKeysService.deleteFacilitiesKeyLock(deletingRow.id)
                    .then(() => {
                        vm.alert(ToastType.Success, `The key lock was successfully deleted`);

                        // Reload the data on the page
                        vm.loadData();
                    }).catch(error => {
                      vm.alert(ToastType.Danger, error.response.data);
                    }).finally(() => {
                      vm.deletingRow = null;
                    })
            }
        },
        created() {
            const vm = this;

            this.loadData();

            AddressService.getAllBuildings()
                .then(response => {
                    vm.buildings = response;
                })
                .catch(error => {
                    vm.buildings = [];
                })
        }
    }
</script>
